/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Access_BlockedInputs */

const cs_franchise_access_blocked = /** @type {(inputs: Franchise_Access_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přístup zablokován`)
};

const en_franchise_access_blocked = /** @type {(inputs: Franchise_Access_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access blocked`)
};

/**
* | output |
* | --- |
* | "Access blocked" |
*
* @param {Franchise_Access_BlockedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_access_blocked = /** @type {((inputs?: Franchise_Access_BlockedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Access_BlockedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_access_blocked(inputs)
	return cs_franchise_access_blocked(inputs)
});